import { useQuery } from '@tanstack/react-query'

const location = async () => fetch(`https://vpnapi.io/api/?key=${process.env.REACT_APP_VPNAPI_KEY}`)
  .then((res) => res.json())

export default function useLocation() {
  const data = useQuery({
    queryKey: ['location'],
    queryFn: location,
  })
  return data
}
